<mat-form-field appearance="fill" *ngIf="appearance === 'fill'">
    <mat-label>{{ label }}</mat-label>
    <mat-select
        panelClass="mat-select-search"
        [sbTestSelector]="sbTestSelector"
        [formControl]="instrument"
        [compareWith]="compareInstrumentFn"
        (opened)="searchInput.focus()"
        (closed)="search.reset()"
        [disabled]="disabled"
        #instrumentSelect
    >
        <mat-select-trigger>
            <!--<i
                *ngIf="codes.get(instrument?.value) as code"
                class="flex-shrink-0 me-1 fp fp-square fp-round fp-{{
                    code.countryCode.toLowerCase()
                }}"
            ></i>-->
            {{ instrument.value?.decoratedInstrumentName || instrument.value?.name }}
        </mat-select-trigger>
        <header>
            <mat-form-field>
                <input
                    #searchInput
                    matInput
                    placeholder="Type to search"
                    type="text"
                    autocomplete="off"
                    [formControl]="search"
                />
            </mat-form-field>
        </header>
        <main *ngIf="!disabled">
            <ng-container *ngIf="instruments$ | async as instruments">
                <!-- Workaround to trigger select if no options available, needed when adding first if using footer -->
                <mat-option
                    *ngIf="
                        instruments?.length < 1 &&
                        (_enableAddNew || addNewInstrumentRouterLink)
                    "
                ></mat-option>

                <mat-option *ngFor="let instrument of instruments" [value]="instrument">
                    <div class="sb-instrument-option d-flex align-items-center">
                        <sb-company-logo
                            [stockTicker]="instrument.instrumentData?.symbol"
                            [companyLogoUrl]="instrument.instrumentData?.logoUrl"
                            [companyWebsite]="instrument.instrumentData?.website"
                            [countryCode]="
                                instrument.instrumentData?.country
                                    | countryCode : instrument.currency
                            "
                            [type]="
                                instrument?.instrumentData?.privateAssetType ??
                                instrument?.type
                            "
                        ></sb-company-logo>
                        <div class="ms-3 d-flex flex-column">
                            <span>
                                {{
                                    instrument.decoratedInstrumentName || instrument.name
                                }}
                            </span>
                            <small class="text-secondary">
                                {{ instrument.type | translate }}
                            </small>
                        </div>
                    </div>
                </mat-option>
            </ng-container>
        </main>
        <footer *ngIf="_enableAddNew">
            <a
                [routerLink]="[
                    '',
                    {
                        outlets: {
                            dialog: [
                                'action',
                                'add-instrument',
                                instrumentTypes$ | async | lowercase
                            ]
                        }
                    }
                ]"
                [sbTestSelector]="sbTestSelector"
                class="btn primary"
                (click)="instrumentSelect.close()"
            >
                Add new
            </a>
        </footer>
        <footer *ngIf="addNewInstrumentRouterLink">
            <a
                #addNewBtn
                [routerLink]="addNewInstrumentRouterLink"
                [queryParams]="searchInput.value ? { search: searchInput.value } : null"
                [sbTestSelector]="sbTestSelector"
                class="btn primary"
                (click)="instrumentSelect.close()"
            >
                Add new
            </a>
        </footer>
    </mat-select>
    <mat-hint>Select instrument</mat-hint>
    <mat-error>
        <ng-container *ngIf="instrument.hasError('required')">
            {{ hint }}
        </ng-container>
    </mat-error>
</mat-form-field>
<mat-select
    class="sb-appearance-none"
    [sbTestSelector]="sbTestSelector"
    panelClass="mat-select-search"
    *ngIf="appearance === 'none'"
    [formControl]="instrument"
    (opened)="searchInput.focus()"
    (closed)="search.reset()"
    [compareWith]="compareInstrumentFn"
    placeholder="Select instrument"
    #instrumentSelect
    [disabled]="disabled"
>
    <mat-select-trigger>
        {{ instrument.value?.decoratedInstrumentName }}
    </mat-select-trigger>
    <header>
        <mat-form-field>
            <input
                #searchInput
                matInput
                placeholder="Type to search"
                type="text"
                autocomplete="off"
                [formControl]="search"
            />
        </mat-form-field>
    </header>
    <main>
        <mat-option *ngFor="let instrument of instruments$ | async" [value]="instrument">
            <div class="sb-instrument-option d-flex align-items-center">
                <sb-company-logo
                    [stockTicker]="instrument.instrumentData?.symbol"
                    [companyLogoUrl]="instrument.instrumentData?.logoUrl"
                    [companyWebsite]="instrument.instrumentData?.website"
                    [countryCode]="
                        instrument.instrumentData?.country
                            | countryCode : instrument.currency
                    "
                    [type]="
                        instrument?.instrumentData?.privateAssetType ?? instrument?.type
                    "
                ></sb-company-logo>
                <div class="ms-3 d-flex flex-column">
                    <span>{{ instrument.decoratedInstrumentName }}</span>
                    <small class="text-secondary">
                        {{ instrument.type | translate }}
                    </small>
                </div>
            </div>
        </mat-option>
    </main>
    <footer *ngIf="addNewInstrumentRouterLink">
        <a
            #addNewBtn
            [routerLink]="addNewInstrumentRouterLink"
            [queryParams]="searchInput.value ? { search: searchInput.value } : null"
            [sbTestSelector]="sbTestSelector"
            class="btn primary"
            (click)="instrumentSelect.close()"
        >
            Add new
        </a>
    </footer>
</mat-select>
